module.exports = __webpack_public_path__ + "static/media/user.64d74e5c.svg";